module.exports = __webpack_public_path__ + "images/emoji/ram.833d976538f59bd99f46.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ram.png
// module id = uUAP
// module chunks = 1